import { render } from "./daysSelector.vue?vue&type=template&id=5aa4d3f4&scoped=true&ts=true"
import script from "./daysSelector.vue?vue&type=script&lang=ts"
export * from "./daysSelector.vue?vue&type=script&lang=ts"

import "./daysSelector.vue?vue&type=style&index=0&id=5aa4d3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa4d3f4"]])

export default __exports__